export default {
    '--q-color-grey-darken' : '#858585',
    '--q-color-primary': '#6380f6',
    '--q-color-primary-2': '#99aeff',
    
    '--q-color-app-background': '#f1eef6',
    '--q-color-app-background-2': '#f7f4f4bb',

    '--q-color-component-background': 'rgb(244, 249, 253)',
    '--q-color-component-background-2': 'rgb(205, 214, 224)',
    '--q-color-component-background-3': '#fff',

    '--q-color-component-shadow': 'rgba(18, 61, 101, 0.57)',
    '--q-color-component-shadow-2': 'rgba(255, 255, 255, 0.2)',
    '--q-color-component-shadow-3': 'rgba(255, 255, 255, 0.18)',

    '--q-color-app-title' : '#31456a',
}
